module.exports = __webpack_public_path__ + "img/remark2.59c9e0d5.png";